import { BatteryGuideContent } from './batteryGuideLayout'
import climateSensor1 from '@modul-connect/shared/img/climateSensor1.png'
import climateSensor2 from '@modul-connect/shared/img/climateSensor2.png'
import alarmSensorImg1 from '@modul-connect/shared/img/alarmSensor1.png'
import alarmSensorImg2 from '@modul-connect/shared/img/alarmSensor2.png'

export const SensorBatteryGuide = () => (
  <BatteryGuideContent
    introText="Remove the old batteries and replace them with new as shown in image. Make sure plus+ and minus- is placed in the correct way."
    batteryType="Type of battery:"
    batteryTypeText="2 x AAA Lithium batteries*"
    batteryTypeText2="2 x CR2032 3V Lithium batteries*"
    footnote="*Using non-lithium batteries will result in inaccurate battery readings."
    subHeading="Climate sensor & Motion sensor"
    subHeading2="Alarm sensor"
    image1={climateSensor1}
    caption1="Remove the old batteries."
    image2={climateSensor2}
    caption2="Insert new batteries. Make sure plus+ and minus- is placed in the correct way."
    image3={alarmSensorImg1}
    caption3="Remove the old batteries."
    image4={alarmSensorImg2}
    caption4="Insert new batteries. Make sure plus+ and minus- is placed in the correct way."

  />
)
